// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__pOMih","HeaderTable":"Table_HeaderTable__SBVHk","RowDataTable":"Table_RowDataTable__q67j2"};